var map = {
	"./bg_club_award.png": 51025,
	"./bg_coach_1.png": 85609,
	"./bg_coach_10.png": 32877,
	"./bg_coach_11.png": 90372,
	"./bg_coach_12.png": 3935,
	"./bg_coach_13.png": 25846,
	"./bg_coach_14.png": 105,
	"./bg_coach_15.png": 45280,
	"./bg_coach_16.png": 315,
	"./bg_coach_2.png": 20466,
	"./bg_coach_3.png": 69467,
	"./bg_coach_4.png": 59524,
	"./bg_coach_5.png": 2029,
	"./bg_coach_6.png": 94998,
	"./bg_coach_7.png": 73087,
	"./bg_coach_8.png": 66536,
	"./bg_coach_9.png": 22833,
	"./bg_history_1990.png": 6605,
	"./bg_history_2000.png": 30266,
	"./bg_history_2010.png": 73893,
	"./bg_history_2020.png": 65856,
	"./bg_team_award.png": 82010,
	"./emblem_1995.png": 27146,
	"./emblem_1997.png": 3416,
	"./emblem_1999.png": 19974,
	"./emblem_2000.png": 34352,
	"./emblem_2006.png": 61478,
	"./emblem_2013.png": 28928,
	"./emblem_2014.png": 56959,
	"./emblem_2018.png": 55523,
	"./emblem_2024.png": 53134,
	"./img_captain_1.png": 32971,
	"./img_captain_10.png": 34563,
	"./img_captain_11.png": 33338,
	"./img_captain_11_1.png": 81534,
	"./img_captain_12.png": 63505,
	"./img_captain_13.png": 49288,
	"./img_captain_2.png": 19152,
	"./img_captain_3.png": 25401,
	"./img_captain_4.png": 6630,
	"./img_captain_5.png": 88175,
	"./img_captain_6.png": 83060,
	"./img_captain_7.png": 4189,
	"./img_captain_8.png": 77066,
	"./img_captain_8_1.png": 73742,
	"./img_captain_9.png": 8979,
	"./img_coach_1.png": 33901,
	"./img_coach_10.png": 3833,
	"./img_coach_11.png": 6928,
	"./img_coach_12.png": 76779,
	"./img_coach_13.png": 55650,
	"./img_coach_14.png": 51997,
	"./img_coach_15.png": 30868,
	"./img_coach_16.png": 49775,
	"./img_coach_2.png": 3574,
	"./img_coach_3.png": 16863,
	"./img_coach_4.png": 65536,
	"./img_coach_5.png": 43657,
	"./img_coach_6.png": 29042,
	"./img_coach_7.png": 43867,
	"./img_coach_8.png": 47628,
	"./img_coach_9.png": 99893,
	"./img_cup_1.png": 50763,
	"./img_cup_10.png": 56931,
	"./img_cup_11.png": 55706,
	"./img_cup_12.png": 85873,
	"./img_cup_13.png": 71656,
	"./img_cup_14.png": 63175,
	"./img_cup_15.png": 44862,
	"./img_cup_16.png": 12213,
	"./img_cup_17.png": 26764,
	"./img_cup_2.png": 36944,
	"./img_cup_3.png": 43193,
	"./img_cup_4.png": 40774,
	"./img_cup_5.png": 5967,
	"./img_cup_6.png": 852,
	"./img_cup_7.png": 21981,
	"./img_cup_8.png": 94858,
	"./img_cup_9.png": 26771,
	"./img_history_2003.png": 6421,
	"./img_history_2004.png": 49914,
	"./img_history_2005.png": 51139,
	"./img_history_2006.png": 65864,
	"./img_history_2009.png": 48127,
	"./img_history_2011.png": 57232,
	"./img_history_2014.png": 42269,
	"./img_history_20147.png": 65750,
	"./img_history_2015.png": 21140,
	"./img_history_2016.png": 26255,
	"./img_history_2018.png": 72577,
	"./img_history_2019.png": 51448,
	"./img_history_2020.png": 18180,
	"./img_history_2021.png": 72077,
	"./img_history_2022.png": 58102,
	"./img_history_intro.png": 59424,
	"./img_permanent_12.png": 48431,
	"./img_permanent_20.png": 19288,
	"./num_permanent_12.png": 92860,
	"./num_permanent_20.png": 37279,
	"./player_history_1990.png": 9719,
	"./player_history_2000.png": 688,
	"./player_history_2010.png": 33947,
	"./player_history_2020.png": 11050
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 62896;